import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    uid: {},
    blh: null,
    certificationProcess: null,
    continueWithMinimum: false,
    equipmentList: [],
    areasList: [],
    pending: false,
    step: 0,
    currPhotoArea: 0,
    currPhotoType: 'vertices'
  },
  actions,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js